module.exports = __webpack_public_path__ + "static/media/loader.61ca6da8.gif";